<template>
  <div class="help-layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'HelpLayout'
}
</script>

<style scoped>
.help-layout {
  min-height: 100vh;
}
</style>
